import { useMemo } from 'react';

import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';

import { usePaymentMethod } from './usePaymentMethod';

const useCheckPagePaymentPermissions = () => {
  const operator = useCurrentOperator();
  const ccPaymentMethods = usePaymentMethod.query.ccMethods();
  const cashPaymentMethods = usePaymentMethod.query.cashMethods();
  const otherPaymentMethods = usePaymentMethod.query.otherMethods();
  const giftCardPaymentMethods = usePaymentMethod.query.giftCardMethods();

  const manualPaymentMethodIds = useMemo(() => 
    (ccPaymentMethods.data ?? []).filter((pm) => pm.fields?.allowManualCardPresent || pm.fields?.allowManualCardNotPresent).map((pm) => pm.id),
  [ccPaymentMethods.data]);
  const ccPaymentMethodIds = useMemo(() => (ccPaymentMethods.data ?? []).map((pm) => pm.id), [ccPaymentMethods.data]);
  const cashPaymentMethodIds = useMemo(() => (cashPaymentMethods.data ?? []).map((pm) => pm.id), [cashPaymentMethods.data]);
  const otherPaymentMethodIds = useMemo(() => (otherPaymentMethods.data ?? []).map((pm) => pm.id), [otherPaymentMethods.data]);
  const giftCardPaymentMethodIds = useMemo(() => (giftCardPaymentMethods.data ?? []).map((pm) => pm.id), [giftCardPaymentMethods.data]);

  return useMemo(() => ({
    splitCheck: {
      isAllowed: operator.permission('pos.checks.split.execute').isAllowed,
    },
    manualPayment: {
      isAllowed: operator.permission('pos.checks.payment.accept.execute').isAllowed && (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).some((id) => manualPaymentMethodIds.includes(id)),
      paymentMethodIds: (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).filter((id) => manualPaymentMethodIds.includes(id)),
    },
    ccPayment: {
      isAllowed: operator.permission('pos.checks.payment.accept.execute').isAllowed && (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).some((id) => ccPaymentMethodIds.includes(id)),
      paymentMethodIds: (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).filter((id) => ccPaymentMethodIds.includes(id)),
    },
    cashPayment: {
      isAllowed: operator.permission('pos.checks.payment.accept.execute').isAllowed && (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).some((id) => cashPaymentMethodIds.includes(id)),
      paymentMethodIds: (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).filter((id) => cashPaymentMethodIds.includes(id)),
    },
    otherPayment: {
      isAllowed: operator.permission('pos.checks.payment.accept.execute').isAllowed && (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).some((id) => otherPaymentMethodIds.includes(id)),
      paymentMethodIds: (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).filter((id) => otherPaymentMethodIds.includes(id)),
    },
    giftCardPayment: {
      isAllowed: operator.permission('pos.checks.payment.accept.execute').isAllowed && (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).some((id) => giftCardPaymentMethodIds.includes(id)),
      paymentMethodIds: (operator.permission('pos.checks.payment.accept.execute').metadata?.paymentMethodIds ?? []).filter((id) => giftCardPaymentMethodIds.includes(id)),
    },
  }), [cashPaymentMethodIds, ccPaymentMethodIds, giftCardPaymentMethodIds, manualPaymentMethodIds, operator, otherPaymentMethodIds]);
};

export { useCheckPagePaymentPermissions };
